import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {OauthService} from './oauth.service';
import {App} from 'ionic-angular';
import {Http} from '@angular/http';
import {ToolsService} from './tools.service';
import {Title} from "@angular/platform-browser";
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class CeService extends OauthService {

  public detail: any;
  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
    private title: Title
  ) {
    super(http, app, appProvider, tools);
  }

  get(code) {
    const url = this.Routing.generate('api_get_ce_code', {'_format': 'json', 'code': code}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders('no-ce')})
      .map(response => response.json().data);
  }

  getDetail() {
    const url = this.Routing.generate('api_get_ce_details', {'_format': 'json'}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders('no-ce')})
      .map(response => {
        this.detail = response.json().data;
        this.title.setTitle(this.detail.data.nom);
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/ce.service.ts